<style lang="scss" scoped>
  @import '../../sass/variables';

  .categories {
    .btn-light {
      color: $salesflow-font-gray;
      background-color: var(--salesflow-bg-body);
      border-color: #edeaf0;
      cursor: pointer;

      /* button select */

      box-sizing: border-box;

      /* Auto layout */

      display: flex;
      flex-direction: row;
      flex-basis: calc(100% / 9);
      align-items: center;
      justify-content: center;
      padding: 0px;

      min-width: 117px!important;
      min-height: 34px!important;

      /* Outline/Gray medium */

      border: 1px solid #D1D1D1;
      border-radius: 12px;

    }

    .btn-light:hover {
      color: $salesflow-font-dark;
      background-color: $salesflow-outline-gray-medium;
      border-color: $salesflow-outline-gray-medium;
    }

    .btn-light:focus,
    .btn-light.focus {
      box-shadow: 0 0 0 0.2rem rgba(216, 217, 219, 0.5);
    }

    .btn-light.disabled,
    .btn-light:disabled {
      color: #212529;
      background-color: #f8f9fa;
      border-color: #f8f9fa;
    }

    .btn-light:not(:disabled):not(.disabled).active {
      color: #130f19;
      background-color: #2CEBA9;
      border-color: #2CEBA9;
    }
  }

  .btn-light {
    color: #212529;
    background-color: #EBEBE8;
    border: 1px solid #D1D1D1;
    border-radius: 12px;
  }

  .btn-light:hover {
    color: #212529;
    background-color: #D1D1D1;
    border-color: #D1D1D1;
  }

  .btn-light:focus,
  .btn-light.focus {
    box-shadow: 0 0 0 0.2rem rgba(216, 217, 219, 0.5);
  }

  .btn-light.disabled,
  .btn-light:disabled {
    color: #212529;
    background-color: #f8f9fa;
    border-color: #f8f9fa;
  }

  .btn-light:not(:disabled):not(.disabled).active {
    color: #130f19;
    background-color: #2CEBA9;
    border-color: #2CEBA9;
  }

  .category-container {
    background: #F0F0F0;
    border: 1px solid #D1D1D1;
    border-radius: 14px;
  }

  .w-1-8 {
    flex: 0 0 100%;
    max-width: 12.5%;
  }

</style>

<template>
  <div
    v-show="show"
    class="row"
  >
    <div class="col-md-12">
      <div class="card card-inverse border border-salesflow-outline-gray-medium bg-salesflow-outline-gray-light">
        <div>
          <div
            v-if="categories === false"
            class="card-body"
          >
            <i class="fa fa-circle-o-notch fa-spin" />
          </div>
          <div
            v-else
            class="card-body"
          >
            <div class="categories row d-flex justify-content-start">
              <!-- <p class="ml-1">Clique em cima da categoria para selecionar</p> -->
              <a
                href="#"
                class="btn btn-light my-2 mx-4 text-center"
                :class="{ active: selected.length === 0 }"
                @click.prevent="reset"
              >
                {{ __('Todas') }}
            </a>

            <a
                v-for="({ id, name }) in categories"
                :key="id"
                href="#"
                class="btn btn-light my-2 mx-4 text-center"
                :class="{ active: selected.indexOf(id) != -1 }"
                @click.prevent="toggle(id)"
              >
                {{ name }}
              </a>
            </div>
            <!-- <button class="btn btn-large btn-box float-right" @click="go">
              Filtrar
            </button> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    route: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      categories: false,
      selected: this.value.map((id) => parseInt(id)).filter((id) => !isNaN(id)),
      show: false,
    };
  },

  created() {
    this.show = !!this.selected.length;

    this.fetch()
      .then(({ data }) => this.categories = data);

    Bus.$on('toggleCategoryFilter', () => this.show = !this.show);
  },

  methods: {
    fetch() {
      return this.$http.get(`/category/${this.type}`);
    },

    toggle(category) {
      const index = this.selected.indexOf(category);

      if (index == -1) {
        this.selected.push(category);
      } else {
        this.selected.splice(index, 1);
      }

      this.go();
    },

    reset() {
      this.selected = [];

      window.location.href = this.route;
    },

    go() {
      window.location.href = `${this.route}?${this.selected.map((id) => `categories[]=${id}`).join('&')}`;
    },

    close() {
      this.show = false;
    },
  },
};
</script>
